/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Load_ErrorInputs */

const en_us2_workout_load_error = /** @type {(inputs: Workout_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load today's workout.`)
};

const pt_br2_workout_load_error = /** @type {(inputs: Workout_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar o treino de hoje.`)
};

const es_419_workout_load_error = /** @type {(inputs: Workout_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo cargar el entrenamiento de hoy.`)
};

const pt_pt2_workout_load_error = /** @type {(inputs: Workout_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar o treino de hoje.`)
};

const fr_fr2_workout_load_error = /** @type {(inputs: Workout_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger la séance du jour.`)
};

const de_de2_workout_load_error = /** @type {(inputs: Workout_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das heutige Training konnte nicht geladen werden.`)
};

const it_it2_workout_load_error = /** @type {(inputs: Workout_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare l'allenamento di oggi.`)
};

/**
* | output |
* | --- |
* | "Couldn't load today's workout." |
*
* @param {Workout_Load_ErrorInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_load_error = /** @type {((inputs?: Workout_Load_ErrorInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Load_ErrorInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_load_error(inputs)
	if (locale === "es-419") return es_419_workout_load_error(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_load_error(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_load_error(inputs)
	if (locale === "de-DE") return de_de2_workout_load_error(inputs)
	if (locale === "it-IT") return it_it2_workout_load_error(inputs)
	return en_us2_workout_load_error(inputs)
});
export { workout_load_error as "workout.load_error" }